module.exports = __webpack_public_path__ + "static/img/brees-2005-slide-5.d355f35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-slide-5.jpg
// module id = Si/6
// module chunks = 1